import { Blinker } from "../../../Common/Blinker"

export const WelcomeScreen = () => {

    return (
        <div className="h-full flex flex-col justify-center items-center text-center">
            <img className="w-[240px] max-w-[240px] mb-[8px]" src='./wowboi-logo.png' alt="" />
            <p className="interactions-text text-xs"> Game Builder & Emulator </p>
            <br />
            <p className="interactions-text text-sm">Press <Blinker interval={600}><span>X</span></Blinker> to continue</p>
        </div>
    )
}

